module.exports = __webpack_public_path__ + "img/2.0e727d36.png";